import { DetailedHTMLProps, HTMLAttributes } from "react";

import styles from "@components/fields/RichTextareaDragAndDrop.module.css";
import useDragAndDropFile from "@hooks/useDragAndDropFile";
import useHandleRichTextareaFiles from "@hooks/useHandleRichTextareaFiles";

type Props = Pick<
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  "className" | "children" | "onClick" | "onKeyDown"
>;

const RichTextareaDragAndDrop = ({ className, ...divProps }: Props) => {
  const handleFiles = useHandleRichTextareaFiles();

  const { isDraggedOver, ...dragAndDropProps } = useDragAndDropFile({
    onDrop: files => handleFiles(files)
  });

  const classList = [className];
  if (isDraggedOver) classList.push(styles.drag);

  return <div {...divProps} {...dragAndDropProps} className={classList.join(" ")} />;
};

export default RichTextareaDragAndDrop;
